// Baut die Mailadresse erst beim Klick zusammen (Schutz vor Spam-Crawlern).
export function openMail(event: MouseEvent): void {
  const { name, domain, tld } = (event.currentTarget as HTMLElement).dataset
  window.location.href = `mailto:${name}@${domain}.${tld}`
}
